import { useTheme } from '@mui/material/styles';
import { Grid, Divider, Container, Typography, Breadcrumbs } from '@mui/material';
// import EventListSection from '../sections/_dashboard/EventListSection';
import PlayStatSection from '../sections/_dashboard/PlayStatSection';

// ----------------------------------------------------------------------

export default function HomePage() {
  const theme = useTheme();

  return (
    <>
      <title> Home </title>

      <Container maxWidth="xl">
        <Breadcrumbs aria-label="breadcrumb">
          <Typography color="text.primary">Home</Typography>
        </Breadcrumbs>

        {/* <Typography variant="h4" sx={{ mb: 5 }}>
          Welcome back, Admin
        </Typography> */}

        <Grid container spacing={3}>
          <Grid item xs={12}>
            <PlayStatSection />
          </Grid>
        </Grid>
      </Container>
    </>
  );
}
